
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/datenschutz",
      function () {
        return require("private-next-pages/legal/datenschutz.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/datenschutz"])
      });
    }
  